<template>
  <div id="app">
    <!-- <app-header /> -->
    <div
      class="app-content"
      :class="{'not-login': $route.path !=='/login'}"
      id="app-content"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
// import AppHeader from "@/components/appHeader";
export default {
  components: {
    // AppHeader,
  },
  name: "App",
  data () {
    return {};
  }
};
</script>
<style lang="css">
html,
body {
  width: 100%;
  height: 100%;
}
body {
  overflow-y: hidden;
  background: #f4f5f7;
}
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.app-content {
  width: 100%;
  height: 100%;
  background: #f4f5f7;
  min-width: 1266px;
  overflow: auto;
}
/* // 不是登陆页的时候高度要减去导航栏的高度，是登陆页时因为独立登陆页没有导航栏不需要减去52px. */
/* .not-login {
  height: calc(100vh - 52px);
} */
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
